import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SoundsNotifyService {

  private urlAudio = environment.urlAudio;
  private audioGol = 'gol.mp3';
  private refereeBegin = 'beginmatch.mp3';
  private refereeEnd = 'endmatch.mp3';

  constructor() { }

  playGold(): void {
    const audio = new Audio();
    audio.src = this.urlAudio + this.audioGol;
    audio.load();
    audio.play();
  }

  playRefereeBegin(): void {
    const audio = new Audio();
    audio.src = this.urlAudio + this.refereeBegin;
    audio.load();
    audio.play();
  }

  playRefereeEnd(): void {
    const audio = new Audio();
    audio.src = this.urlAudio + this.refereeEnd;
    audio.load();
    audio.play();
  }
}
